import { useNavigate } from 'react-router-dom';
import { AccountPageHeader } from '../../account/components/AccountPageHeader';
import { ProductDiscoveryGrid } from '../../browse/components/ProductDiscoveryGrid';
import { useSavedItemsQuery } from '../wishlist.services';
import { mapApiProductToUI } from '../../home';
import { EmptyState, Button } from '@shopmuchmore/design-system';
import { Heart } from 'lucide-react';

export function WishlistPage() {
    const navigate = useNavigate();
    const { data: savedItems, isLoading } = useSavedItemsQuery();

    const products = savedItems?.map(item => mapApiProductToUI({
        name: item.name,
        product_slug: item.product_slug,
        merchant_name: item.merchant_name,
        price: item.price,
        promo_price: item.promo_price,
        main_thumbnail: item.main_thumbnail,
        availability: item.availability,
        vat_included: item.vat_included,
        average_rating: item.average_rating,
        review_count: item.review_count,
        discount_percentage: Number.parseFloat(item.discount_percentage || '0'),
        stockleft: item.stockleft,
        in_campaign: item.in_campaign,
        description: '' // Not available in saved item summary
    })) || [];


    return (
        <div className="w-full space-y-8">
            <AccountPageHeader
                title="My Wishlist"
                description="Save items you love and buy them later."
            />

            {isLoading ? (
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    {Array.from({ length: 4 }).map((_, i) => (
                        <div key={i} className="aspect-[4/5] bg-gray-50 rounded-2xl animate-pulse" />
                    ))}
                </div>
            ) : products.length > 0 ? (
                <ProductDiscoveryGrid products={products} columns={4} />
            ) : (

                <EmptyState
                    icon={Heart}
                    title="Your wishlist is empty"
                    description="Save items you're interested in and they'll show up here so you can easily find them later."
                    iconClassName="bg-red-50"
                    action={
                        <Button 
                            variant="secondary" 
                            onClick={() => navigate('/browse')}
                        >
                            Browse Products
                        </Button>
                    }
                />
            )}
        </div>
    );
}
